
import { useScrollAnimation, getAnimationClass } from '../../../hooks/useScrollAnimation';

function AnimatedSection({ children, animation = 'slide-up' as 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in', className = '' }: { children: React.ReactNode; animation?: 'fade-in' | 'slide-up' | 'slide-left' | 'slide-right' | 'scale-in'; className?: string }) {
  const { ref, isVisible } = useScrollAnimation();
  return (
    <div ref={ref} className={`${getAnimationClass(isVisible, animation)} ${className}`}>
      {children}
    </div>
  );
}

export default function Mission() {
  return (
    <section className="py-24 bg-gradient-to-br from-emerald-600 to-emerald-700 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <AnimatedSection animation="fade-in">
          <div className="text-center mb-16">
            <span className="inline-block text-xs font-semibold text-emerald-200 uppercase tracking-widest mb-3">Nuestra Misión</span>
            <h2 className="text-3xl lg:text-4xl font-bold text-white mb-6 max-w-3xl mx-auto leading-tight">
              Democratizar el acceso a tecnología de <span className="font-display italic">vanguardia</span> para profesionales de la salud visual
            </h2>
          </div>
        </AnimatedSection>

        <div className="grid md:grid-cols-3 gap-6">
          {[
            {
              icon: 'ri-lightbulb-line',
              title: 'Visión',
              desc: 'Ser la plataforma SaaS de referencia global para la gestión clínica oftalmológica, conectando profesionales, pacientes y tecnología en un ecosistema unificado.',
            },
            {
              icon: 'ri-heart-pulse-line',
              title: 'Misión',
              desc: 'Empoderar a los profesionales de la salud visual con herramientas digitales intuitivas que optimicen su práctica, mejoren la atención al paciente y reduzcan la carga administrativa.',
            },
            {
              icon: 'ri-compass-3-line',
              title: 'Propósito',
              desc: 'Cada línea de código que escribimos tiene un objetivo: que los oftalmólogos dediquen más tiempo a cuidar la visión de sus pacientes y menos a tareas administrativas.',
            },
          ].map((item, index) => (
            <AnimatedSection key={index} animation="scale-in">
              <div className="bg-white/10 backdrop-blur-sm p-8 rounded-xl border border-white/15 hover:bg-white/15 transition-all cursor-pointer h-full">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-5">
                  <i className={`${item.icon} text-white text-2xl`}></i>
                </div>
                <h3 className="text-lg font-bold text-white mb-3">{item.title}</h3>
                <p className="text-sm text-white/80 leading-relaxed">{item.desc}</p>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}
